<div class="d-flex box w-100 h-100 flex-wrap">
  <bdg-label
    [ngClass]="filename ? 'w-100' : ''"
    class="py-2 px-3 align-self-center"
    type="body-1"
    [required]="required"
    >{{ title }}</bdg-label
  >
  <bdg-label class="d-flex py-2 px-3 align-items-center" *ngIf="filename" type="body-1">
    <a href="javascript:void(0)" (click)="download()">
      <div class="d-flex">
        {{ filename }}
        <mat-icon class="ml-2" style="color: black; margin-top: -2px">get_app</mat-icon>
      </div>
    </a>
  </bdg-label>
  <div class="py-2 px-3 ml-auto">
    <input id="file" type="file" class="d-none" #fileInput [accept]="accept" (change)="onChange($event)" />
    <input matInput class="d-none" [formControl]="control" />
    <div class="d-flex">
      <bdg-button
        [disabled]="disabled"
        *ngIf="!isUploading && !arquivo"
        class="primary"
        label="ANEXAR ARQUIVO"
        matIcon="publish"
        (click)="onClick(fileInput)"
      >
      </bdg-button>
      <bdg-button
        *ngIf="arquivo"
        class="primary"
        label="REMOVER ANEXO"
        matIcon="delete"
        [disabled]="disabled"
        (click)="removeFile()"
      >
      </bdg-button>
      <div *ngIf="isUploading" class="ml-2 d-flex justify-content-center align-items-start">
        <bdg-label class="mr-3" type="body-1">Enviando...</bdg-label>
        <mat-spinner diameter="20" hint="Enviando arquivo"></mat-spinner>
      </div>
      <div *ngIf="hasError" class="ml-2 align-self-center">
        <mat-icon matSuffix class="mat-error">error</mat-icon>
      </div>
    </div>
  </div>
</div>

<mat-error class="mat-form-field" *ngIf="hasError">
  <span style="font-size: 0.8em; margin-top: 0.25em; letter-spacing: calc(0.05em - 0.2px)">{{ errorMessage }}</span>
</mat-error>
